export default __webpack_public_path__ + "static/media/studentModalTestSeries.a9a3ce97.svg";